module.exports = __webpack_public_path__ + "img/Video.721f1cf8.svg";